































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import AppConsts from "@/lib/appconst";
import _ from "lodash";
import * as moment from "moment";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import ViewJob from "./employee-job-diary-detail.vue";

class PagEmployeeJobDiaryRequest extends PageRequest {
  warehouseCode: string;
  employeeId: number;
  workOrderTypeCode: string;
  fromDate: string;
  toDate: string;
  isWorking: boolean = false;
  pageSize: number;
  pageNumber: number;
}

@Component({
  components: { "view-job": ViewJob },
})
export default class EmployeeJobDiary extends mixins(ListMixin, AbpBase) {
  namespace = "employeeJobDiary";
  creationTime: Date[] = [];
  employees = [];
  warehouses = [];
  workOrderTypes = [];
  viewModalShow: boolean = false;
  objectLoading: boolean = false;
  viewDateWarning() {
    var argus = [AppConsts.reportRangeDays.range180.toString()];
    return Util.L("RangeDaysTooltip", "", ...argus);
  }
  //filters
  pagerequest: PagEmployeeJobDiaryRequest = new PagEmployeeJobDiaryRequest();

  get store() {
    return this.$store.state.employeeJobDiary;
  }
  isTenant() {
    return this.$store.state.session.tenant != null;
  }
  get tenant() {
    return this.$store.state.session.tenant;
  }
  changeWarehouse() {
    delete this.pagerequest.employeeId;
    this.employees = [];
  }

  async getWarehouses() {
    await this.$store
      .dispatch({
        type: "warehouse/getListForSelect",
        data: { hasAllItem: false },
      })
      .then(() => {
        var re = this.$store.state.warehouse.warehousesForSelect;
        if (this.isTenant()) {
          this.pagerequest.warehouseCode = this.tenant.tenancyName;
        } else {
          this.pagerequest.warehouseCode = re.length === 0 ? "" : re[0].id;
        }
        this.warehouses = re;
      });
  }
  //Filter
  searchEmployeesOfWarehouse_OnPress = _.debounce(
    this.searchEmployeesOfWarehouse,
    AppConsts.debounceDelayTime,
    {
      leading: false,
      trailing: true,
    }
  );

  async searchEmployeesOfWarehouse(keyword) {
    if (
      Util.isEmpty(keyword) ||
      keyword.length < AppConsts.keyWordAtleastLength
    )
      return;
    this.objectLoading = true;
    const request = {
      warehouseCode: this.pagerequest.warehouseCode,
      keyword,
    };
    await this.$store
      .dispatch({
        type: "user/searchEmployeesOfWarehouse",
        data: request,
      })
      .then((res) => {
        this.objectLoading = false;
        res.forEach((element) => {
          element.formatName = `${element.userName} - ${element.name}`;
        });
        res.unshift({ id: -1, formatName: this.L(AppConsts.All) });
        this.employees = res;
      });
  }

  async getWorkOrderTypes() {
    await this.$store
      .dispatch({
        type: `${this.namespace}/getWorkOrderTypeForSelect`,
        data: {
          hasAllItem: true,
        },
      })
      .then((re) => {
        this.$set(this.pagerequest, "workOrderTypeCode", re[0].code);
        this.workOrderTypes = re;
      });
  }
  search() {
    this.pageChange(1);
  }
  preGetPage() {
    if (
      this.creationTime.length > 0 &&
      !_.isNil(this.creationTime[0]) &&
      this.creationTime[0].toString() !== ""
    ) {
      this.pagerequest.fromDate = moment(this.creationTime[0])
        .startOf("d")
        .utc()
        .format();
    } else {
      this.pagerequest.fromDate = null;
    }
    if (
      this.creationTime.length > 1 &&
      !_.isNil(this.creationTime[1]) &&
      this.creationTime[1].toString() !== ""
    ) {
      this.pagerequest.toDate = moment(this.creationTime[1])
        .endOf("d")
        .utc()
        .format();
    } else {
      this.pagerequest.toDate = null;
    }
    this.pagerequest.pageSize = this.pageSize;
    this.pagerequest.pageNumber = this.currentPage;
  }
  view(value: any) {
    this.preGetPage();
    var param = {
      warehouseName: value.warehouseName,
      employeeCode: value.employeeCode,
      employeeName: value.employeeName,
      pagerequest: {
        warehouseCode: this.pagerequest.warehouseCode,
        employeeId: value.employeeId,
        isWorking: this.pagerequest.isWorking,
        workOrderTypeCode: this.pagerequest.workOrderTypeCode,
        fromDate: this.pagerequest.fromDate,
        toDate: this.pagerequest.toDate,
        pageNumber: 1,
        pageSize: this.pagerequest.pageSize,
      },
    };
    this.$store.commit(`${this.namespace}/view`, param);
    this.viewModalShow = true;
  }
  async exportToExcel() {
    this.preGetPage();
    await this.$store.dispatch({
      type: `${this.namespace}/exportEmployeeJobDiary`,
      data: this.pagerequest,
    });
  }
  async created() {
    await this.getWarehouses();
    await this.getWorkOrderTypes();
    this.creationTime = Util.buildDefaultViewDate(
      AppConsts.reportRangeDays.range15
    );
    if (this.isTenant()) {
      this.pagerequest.warehouseCode = this.tenant.tenancyName;
    }
    this.search();
  }
  columns = [
    {
      title: Util.L("Warehouse"),
      key: "warehouseName",
      width: 150,
    },
    {
      title: Util.L("EmployeeCode"),
      key: "employeeCode",
      width: 150,
    },
    {
      title: Util.L("Name"),
      key: "employeeName",
    },
    {
      title: Util.L("WorkOrder"),
      key: "workOrderName",
    },
    {
      title: Util.L("TotalTaskQty"),
      key: "totalWorkOrder",
      align: "right",
      width: 150,
      render: (h, params) => {
        return h("span", Util.toViewNumberString(params.row.totalWorkOrder));
      },
    },
    {
      title: Util.L("Action"),
      slot: "action",
      align: "center",
      width: 100,
    },
  ];
}
